import { useEffect, useState } from "react";
import "./SubSection.css";
import { Link } from "react-router-dom";

const SubSection = ({
  title = "Most Talked About",
  subtitle = "Latest updates and trending content",
  children,
  dark,
  width = "25%",
}) => {
  const createSlug = (homeTeam, awayTeam) => {
    return [homeTeam, awayTeam]
      .filter(Boolean)
      .join(" ")
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-");
  };

  const [featuredPosts, setFeaturedPosts] = useState([]);
  const [trendingTeams, setTrendingTeams] = useState([]);
  const [latestVideos, setLatestVideos] = useState([]);
  const [featuredMatches, setFeaturedMatches] = useState([]);
  const [popularNews, setPopularNews] = useState([]);
  const [breakingnews, setBreakingNews] = useState([]);
  const [trendingPlayers, setTrendingPlayers] = useState([]);
  const [categoryPosts, setCategoryPosts] = useState([]);
  const [mostTalkedAbout, setMostTalkedAbout] = useState([]);

  const [loadingMostTalkedAbout, setLoadingMostTalkedAbout] = useState(true);
  const [loadingHome, setLoadingHome] = useState(true);
  const [loadingVideos, setLoadingVideos] = useState(true);
  const [loadingMatches, setLoadingMatches] = useState(true);
  const [loadingNews, setLoadingNews] = useState(true);
  const [loadingPlayers, setLoadingPlayers] = useState(true);
  const [loadingPosts, setLoadingPosts] = useState(true);
  const [loadingBreakingNews, setLoadingBreakingNews] = useState(true);
  const [loadingFeaturedMatches, setLoadingFeaturedMatches] = useState(true);
  const [competitionPosts, setCompetitionPosts] = useState([]);
  const [loadingCompetitionPosts, setLoadingCompetitionPosts] = useState(true);

  const [matches, setMatches] = useState([]);

  const formatLocalDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const [selectedDate, setSelectedDate] = useState(formatLocalDate(new Date()));

  const [selectedLeague, setSelectedLeague] = useState("all");

  const [competition, setCompetitions] = useState([]);
  const [competitionsError, setCompetitionsError] = useState();
  const [competitionloading, setCompetitionsLoading] = useState();
  const [latestPosts, setLatestPosts] = useState([]);
  const [loadingLatestPosts, setLoadingLatestPosts] = useState(true);

  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(null);
  const [loadingMore, setLoadingMore] = useState(false);

  const [selectedLeagueId, setSelectedLeagueId] = useState(null);

  const [Loading, setLoading] = useState();
  const [error, setError] = useState();
  const [leagueInfo, setLeagueInfo] = useState();
  const [rank, setRank] = useState();
  const [standings, setStandings] = useState();

  const [homeColors, setHomeColors] = useState({});
  const [awayColors, setAwayColors] = useState({});

  const isSidebarLoading =
    loadingHome ||
    loadingVideos ||
    loadingMatches ||
    loadingNews ||
    loadingPlayers ||
    loadingPosts ||
    loadingBreakingNews ||
    loadingFeaturedMatches ||
    loadingMostTalkedAbout;

  useEffect(() => {
    const fetchHome = async () => {
      try {
        setLoadingHome(true);
        setLoadingVideos(true);
        setLoadingMatches(true);
        setLoadingNews(true);
        setLoadingPlayers(true);
        setLoadingPosts(true);
        setLoadingBreakingNews(true);
        setLoadingFeaturedMatches(true);

        const CACHE_KEY = "home_cache";
        const CACHE_TIME_KEY = "home_cache_time";
        const THIRTY_MINUTES = 30 * 60 * 1000;

        const cachedData = localStorage.getItem(CACHE_KEY);
        const cachedTime = localStorage.getItem(CACHE_TIME_KEY);

        if (cachedData && cachedTime) {
          const now = new Date().getTime();

          if (now - cachedTime < THIRTY_MINUTES) {
            const data = JSON.parse(cachedData);

            setFeaturedPosts(data?.data?.featured_posts || []);
            setTrendingTeams(data?.data?.trending_teams || []);
            setLatestVideos(data?.data?.latest_videos || []);
            setPopularNews(data?.data?.most_read_news || []);
            setBreakingNews(data?.data?.breaking_news || []);
            setTrendingPlayers(data?.data?.trendy_players || []);
            setCategoryPosts(data?.data?.category_sections || []);

            const live = data?.data?.live_matches || [];
            const upcoming = data?.data?.upcoming_matches || [];
            setMatches([...live, ...upcoming]);

            setLoadingHome(false);
            setLoadingVideos(false);
            setLoadingMatches(false);
            setLoadingNews(false);
            setLoadingPlayers(false);
            setLoadingPosts(false);
            setLoadingBreakingNews(false);

            return;
          }
        }

        const res = await fetch("https://workplace.fadawebs.com/api/home");
        const data = await res.json();

        localStorage.setItem(CACHE_KEY, JSON.stringify(data));
        localStorage.setItem(CACHE_TIME_KEY, new Date().getTime());

        setFeaturedPosts(data?.data?.featured_posts || []);
        setTrendingTeams(data?.data?.trending_teams || []);
        setLatestVideos(data?.data?.latest_videos || []);
        setPopularNews(data?.data?.most_read_news || []);
        setBreakingNews(data?.data?.breaking_news || []);
        setTrendingPlayers(data?.data?.trendy_players || []);
        setCategoryPosts(data?.data?.category_sections || []);

        const live = data?.data?.live_matches || [];
        const upcoming = data?.data?.upcoming_matches || [];
        setMatches([...live, ...upcoming]);
      } catch (err) {
        console.error("Error fetching home data:", err);
      } finally {
        setLoadingHome(false);
        setLoadingVideos(false);
        setLoadingMatches(false);
        setLoadingNews(false);
        setLoadingPlayers(false);
        setLoadingPosts(false);
        setLoadingBreakingNews(false);
      }
    };

    fetchHome();
  }, []);

  useEffect(() => {
    const fetchFeaturedMatches = async () => {
      try {
        setLoadingFeaturedMatches(true);

        const res = await fetch(
          `https://workplace.fadawebs.com/api/matches/featured?date=${selectedDate}`,
        );

        const data = await res.json();

        setFeaturedMatches(data?.data || []);
      } catch (err) {
        console.error("Error fetching featured matches:", err);
      } finally {
        setLoadingFeaturedMatches(false);
      }
    };

    fetchFeaturedMatches();
  }, [selectedDate]);

  useEffect(() => {
    const TalkedAboutPosts = async () => {
      try {
        setLoadingMostTalkedAbout(true);

        const CACHE_KEY = "most_talked_about_cache";
        const CACHE_TIME_KEY = "most_talked_about_cache_time";
        const THIRTY_MINUTES = 30 * 60 * 1000;

        const cachedData = localStorage.getItem(CACHE_KEY);
        const cachedTime = localStorage.getItem(CACHE_TIME_KEY);

        if (cachedData && cachedTime) {
          const now = new Date().getTime();

          if (now - cachedTime < THIRTY_MINUTES) {
            const parsed = JSON.parse(cachedData);

            setMostTalkedAbout(parsed?.data?.data || []);

            setLoadingMostTalkedAbout(false);

            return;
          }
        }

        const res = await fetch(
          "https://workplace.fadawebs.com/api/posts/most-talked-about",
        );

        const data = await res.json();

        localStorage.setItem(CACHE_KEY, JSON.stringify(data));
        localStorage.setItem(CACHE_TIME_KEY, new Date().getTime());

        setMostTalkedAbout(data?.data?.data || []);
      } catch (err) {
        console.error("Error fetching most talked about posts:", err);
      } finally {
        setLoadingMostTalkedAbout(false);
      }
    };

    TalkedAboutPosts();
  }, []);

  return (
    <section
      className={`subsection ${dark ? "dark-subsection" : ""}`}
      style={{ width, minWidth: "240px", flexShrink: 0 }}>
      {isSidebarLoading && (
        <section className="subsection-loading column">
          <div className="sub-card skeleton-card" />
          <div className="sub-card skeleton-card" />
          <div className="sub-card skeleton-card" />
        </section>
      )}
      <section className="fifthsection column">
        {featuredMatches.length !== 0 && (
          <h1
            className="title"
            style={dark ? { color: "whitesmoke" } : { color: "#161819" }}>
            Featured match
          </h1>
        )}

        {featuredMatches?.slice(0, 1)?.map((match, index) => (
          <Link
            key={index}
            to={`/matches/${createSlug(
              match?.teams?.home?.name,
              match?.teams?.away?.name,
            )}/${match?.fixture?.id}`}
            state={{ matchId: match?.fixture?.id }}
            style={{ minWidth: "100%" }}>
            <div key={index}>
              <span>
                <h2>
                  <strong
                    style={
                      {
                        // color: getTeamColor(match?.teams?.home?.id)
                      }
                    }
                    className="ss">
                    {match?.teams?.home?.code}
                  </strong>

                  <strong
                    style={
                      {
                        // color: getTeamColor(match?.teams?.away?.id)
                      }
                    }>
                    {match?.teams?.away?.code}
                  </strong>
                </h2>

                <h3>
                  {match?.league?.name},{" "}
                  <b style={{ textTransform: "uppercase" }}>
                    {match?.fixture?.venue?.name}
                  </b>
                </h3>

                <h4>
                  {new Date(match?.fixture?.date).toLocaleDateString([], {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}{" "}
                  •{" "}
                  {new Date(match?.fixture?.date).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false,
                  })}
                </h4>
              </span>

              <nav>
                <Link
                  to={`/teams/${match?.teams?.home?.name
                    ?.replace(/\s+/g, "")
                    .toLowerCase()}-${match?.teams?.home?.id}`}
                  style={{ textDecoration: "none", color: "inherit" }}>
                  <img src={match?.teams?.home?.logo} alt="home team" />
                </Link>

                <b style={{ marginTop: "15px" }}>VS</b>

                <Link
                  to={`/teams/${match?.teams?.away?.name
                    ?.replace(/\s+/g, "")
                    .toLowerCase()}-${match?.teams?.away?.id}`}
                  style={{ textDecoration: "none", color: "inherit" }}>
                  <img src={match?.teams?.away?.logo} alt="away team" />
                </Link>
              </nav>
            </div>
          </Link>
        ))}
      </section>

      {loadingPlayers ? (
        <section className="sixthsection column">
          <div className="highlight">
            <div className="slide1">
              {[1, 2, 3].map((_, i) => (
                <div key={i} className="imgdiv1 skeleton skeleton-player"></div>
              ))}
            </div>
          </div>
        </section>
      ) : trendingPlayers.length === 0 ? (
        <p></p>
      ) : (
        <section
          className="sixthsection column"
          style={
            dark ? { backgroundColor: "#333" } : { backgroundColor: "white" }
          }>
          <h1
            className="title"
            style={dark ? { color: "whitesmoke" } : { color: "#161819" }}>
            Trending Players
          </h1>

          <div className="highlight">
            <div className="slide1">
              {trendingPlayers?.map((players, index) => (
                <div className="imgdiv1" key={index}>
                  <img src={players.photo} alt="" className="behind" />

                  <p>
                    {(() => {
                      const team =
                        players?.statistics?.team ||
                        players?.metadata?.team ||
                        players?.team;

                      if (!team) return null;

                      return (
                        <Link
                          to={`/teams/${team?.name
                            ?.replace(/\s+/g, "")
                            .toLowerCase()}-${team?.id}`}
                          style={{
                            textDecoration: "none",
                            color: "inherit",
                          }}>
                          <img
                            src={team?.logo}
                            alt={team?.name}
                            className="mylogos"
                          />
                        </Link>
                      );
                    })()}

                    <strong>
                      {players?.metadata?.player?.name || players?.name}
                    </strong>

                    <Link
                      to={`/players/${players?.name
                        ?.trim()
                        .replace(/[^a-zA-Z.\s]/g, "")
                        .replace(/\s+/g, "-")
                        .toLowerCase()}-${players?.api_id}`}
                      state={{ player: players }}
                      key={players?.id}>
                      <button>View Player</button>
                    </Link>
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {loadingBreakingNews ? (
        <></>
      ) : // <section className="seventhsection">
      //   <div className="skeleton skeleton-breaking"></div>
      // </section>
      breakingnews.length === 0 ? (
        <p></p>
      ) : (
        <section
          className="seventhsection"
          style={
            dark
              ? {
                  backgroundColor: "#ca10107c",
                  color: "rgba(231, 231, 231, 1)",
                }
              : { backgroundColor: "#FE0000", color: "#161819" }
          }>
          <h1>Breaking News</h1>
          {breakingnews.slice(0, 1)?.map((news, index) => (
            <div>
              <div className="imgdiv2">
                <img src={news.image} alt="" />
              </div>
              <nav>
                <h2
                  style={
                    dark ? { color: "#fafafaff" } : { color: "#fafafaff" }
                  }>
                  {news?.title?.length > 50
                    ? news?.title.slice(0, 50) + "..."
                    : news?.title}
                </h2>
                {/* <p style={dark ? {color: "#fafafaff"} : {color: "#fafafaff"}}>
                                {news?.excerpt?.length > 30
                                  ? news?.excerpt.slice(0, 30) + "..."
                                  : news?.excerpt} </p> */}

                <Link to={`/news/${news?.slug}`} key={index}>
                  <button
                    style={
                      dark
                        ? {
                            backgroundColor: "#cfcfcfff",
                            color: "rgba(107, 31, 31, 1)",
                          }
                        : { backgroundColor: "white", color: "" }
                    }>
                    View more details
                  </button>
                </Link>
              </nav>
            </div>
          ))}
        </section>
      )}

      {!loadingMostTalkedAbout && mostTalkedAbout?.length > 0 && (
        <>
          <section
            className="eightsection"
            style={
              dark ? { backgroundColor: "#333" } : { backgroundColor: "white" }
            }>
            <div className="subsection-header">
              <div>
                <h2>Most Talked About</h2>
              </div>
            </div>

            <div className="subsection-content">
              {mostTalkedAbout?.slice(0, 10)?.map((item, index) => (
                <Link
                  key={item?.id || index}
                  to={`/news/${item?.slug}`}
                  state={{ post: item }}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                  }}>
                  <div className="sub-card">
                    <img src={item?.image} alt="" />

                    <div>
                      <h3>
                        {" "}
                        {item?.title?.length > 60
                          ? item?.title.slice(0, 60) + "..."
                          : item?.title}
                      </h3>

                      {/* <p>
                        {item?.excerpt?.slice(0, 90)}
                        {item?.excerpt?.length > 90 ? "..." : ""}
                      </p> */}

                      {/* <small>
                        👁 {item?.views_count || 0} views
                      </small> */}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        </>
      )}
    </section>
  );
};

export default SubSection;
